import React, { ComponentType, FC } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { PatternFormat } from 'react-number-format';

interface Props {
  format: string;
  className?: string;
  customInput?: ComponentType<any>;
}

export const InputMaskField: FC<Props & TextFieldProps> = ({
  format,
  value,
  disabled,
  onChange,
  className = '',
  customInput,
  ...resProps
}) => {
  return (
    // @ts-ignore
    <PatternFormat
      {...resProps}
      customInput={customInput ?? TextField}
      value={value as any}
      className={className}
      format={format}
      disabled={disabled}
      onValueChange={({ value: v }) => {
        if (!onChange) {
          return;
        }

        // @ts-ignore
        onChange({ target: { value: v } });
      }}
    />
  );
};
